/** @deprecated , use getURLParamValue */
export const getUrlParams = (param: string) => {
    const params = new URLSearchParams(location.search);
    const paramsObject = Object && Object.fromEntries(params.entries());
    return paramsObject[param];
};

export const getAllUrlParams = (url?: string): URLSearchParams =>
    new URLSearchParams(url ?? location.search);

export const getUrlForLegacyHib = (): URLSearchParams =>
    removeURLParam(getAllUrlParams(), 'page');

export const hasUrlParam = (param: string, url?: string): boolean =>
    getAllUrlParams(url).has(param);

export const getURLParamValue = (param: string, url?: string): string | null =>
    getAllUrlParams(url).get(param);

export const removeURLParam = (
    searchParams: URLSearchParams,
    paramName: string
): URLSearchParams => {
    searchParams.delete(paramName);

    return searchParams;
};

export const changeURLParam = (
    paramName: string,
    paramValue: string,
    searchParams?: URLSearchParams
): URLSearchParams => {
    if (!searchParams) {
        searchParams = getAllUrlParams();
    }
    searchParams.set(paramName, paramValue);

    return searchParams;
};

// search for given param value in document url
// if found, add it to the given url and return url string
export const updateURLParamString = (param: string, url: string): string => {
    const paramToFind = getURLParamValue(param);

    if (!!paramToFind) {
        return decodeURIComponent(
            changeURLParam(param, paramToFind, getAllUrlParams(url)).toString()
        );
    }

    return url;
};

export interface UrlParam {
    key: string;
    value: string;
}

/* replace or add params in url */
export const replaceParamListInUrl = (
    url: string,
    paramList: UrlParam[]
): string => {
    const [host, queryParams] = url.split('?');
    let urlSearchParams = new URLSearchParams(queryParams);

    paramList.forEach((param) => {
        urlSearchParams = changeURLParam(
            encodeURIComponent(param.key),
            encodeURIComponent(param.value),
            urlSearchParams
        );
    });

    return `${host}?${urlSearchParams.toString()}`;
};

export const getCurrentUrlWithoutParams = (): string => {
    return `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
};

export enum HotelDetailType {
    Equipment = 'equipment',
    Description = 'hotel',
    Rating = 'rating',
    Media = 'media',
    Hygiene = 'hygiene',
    Map = 'map',
}

export function getApiUrl(
    type = HotelDetailType.Description,
    hotelId: number,
    urlParams: URLSearchParams,
    isPopup = false
) {
    const route = isPopup ? 'hib_popup' : 'hib';
    const url = new URL(
        `${location.origin}/${route}/${hotelId.toString()}/${type}`
    );
    urlParams.forEach((value, key) => {
        const keyParam = isPopup ? `offerListParams[${key}]` : key;
        url.searchParams.set(keyParam, value);
    });
    return url.toJSON();
}

export function fromObject(object: Record<string, unknown>) {
    const params = new URLSearchParams();
    Object.entries(object).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
            params.append(key, String(value));
        }
    });
    return params;
}

export enum MergeMode {
    Append = 'append',
    Set = 'set',
}

export function merge(mode: MergeMode, ...args: URLSearchParams[]) {
    const baseParams = new URLSearchParams();
    args.forEach((params) => {
        for (const keyValuePair of params) {
            baseParams[mode](...keyValuePair);
        }
    });
    return baseParams;
}

const URLSearchParamsUtil = {
    fromObject,
    merge,
};

export default URLSearchParamsUtil;
